import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { Module } from '@library/store/modules/modules.interface';
import { Room } from '@library/store/rooms/rooms.interface';
import { combineLatest, map, tap } from 'rxjs';

export interface ConsumptionGroup {
  id: string;
  value: number;
  ratio: number;
  color?: string;
  rows: {
    module: Module,
    value: number,
    room: Room,
    ratio: number,
    color?: string
  }[],
}

export const AppliancesTab = {
  label: 'legrand-app.__APPLIANCES',
  id: 'appliances',
};

export const PowerLinesTab = {
  label: 'legrand-app.__POWER_LINES',
  id: 'powerlines',
};

@Component({
  selector: 'app-control-page-footer-consumption',
  templateUrl: './control-page-footer-consumption.component.html',
  styleUrls: ['./control-page-footer-consumption.component.scss']
})
export class ControlPageFooterConsumptionComponent {

  @Input() selectedTab = 'appliances';
  @Output() selectedTabChange = new EventEmitter<string>();

  tabs$ = combineLatest({
    appliances: this.modulesFacade.appliances$,
    powerlines: this.modulesFacade.powerLines$,
  }).pipe(
    map(({appliances, powerlines}) => {
      const tabs = [];
      if (appliances.length > 0) {
        tabs.push(AppliancesTab);
      }
      if (powerlines.length > 0) {
        tabs.push(PowerLinesTab);
      }
      return tabs;
    }),
    tap((tabs) => {
      if (tabs.length > 0) {
        this.selectedTab = tabs[0].id;
      }
    })
  );

  constructor(
    private modulesFacade: ModulesFacade,
  ) {}

  getSelectedTabIndex(tabs: {id: string}[]) {
    return tabs.findIndex(t => t.id === this.selectedTab);
  }

}
